const SOURCE_TAG_COLORS = [
  { background: '#fff2ec', border: '#ffbb96', text: '#ad2102' },
  { background: '#e6f7ff', border: '#91d5ff', text: '#0050b3' },
  { background: '#f6ffed', border: '#b7eb8f', text: '#237804' },
  { background: '#f9f0ff', border: '#d3adf7', text: '#531dab' },
  { background: '#fffbe6', border: '#ffe58f', text: '#ad6800' },
  { background: '#e6fffb', border: '#87e8de', text: '#006d75' },
  { background: '#fff0f6', border: '#ffadd2', text: '#9e1068' },
];

export const getCandidateSourceLabel = (source?: string) => String(source || 'Manual entry').trim();

export const getCandidateSourceTagColors = (source?: string) => {
  const label = getCandidateSourceLabel(source).toLowerCase();
  const hash = Array.from(label).reduce(
    (value, character) => (value * 31 + character.charCodeAt(0)) >>> 0,
    0,
  );
  return SOURCE_TAG_COLORS[hash % SOURCE_TAG_COLORS.length];
};
